export default function Captcha() {
  let nc;
  let el;
  let callback;
  this.render = function (args) {
    el = args.el;
    el.find('.captcha-afs').attr('id', el.data('id'));
    let nc_token = [el.data('key'), new Date().getTime(), Math.random()].join(':');
    let NC_Opt = {
      renderTo: '#' + el.data('id'),
      appkey: el.data('key'),
      scene: 'nc_login',
      token: nc_token,
      customWidth: el.data('width'),
      trans: { key1: 'code0' },
      elementID: ['usernameID'],
      is_Opt: 0,
      language: el.data('lang'),
      isEnabled: true,
      timeout: 3000,
      times: 5,
      apimap: {},
      callback: function (data) {
        el.find('input[name=csessionid]').val(data.csessionid);
        el.find('input[name=sig]').val(data.sig);
        el.find('input[name=nc_token]').val(nc_token);
        if (callback instanceof Function) callback();
      },
    };
    nc = new noCaptcha(NC_Opt);
    nc.upLang(el.data('lang'));
  };
  this.reset = function () {
    el.find('input[name=csessionid]').val('');
    el.find('input[name=sig]').val('');
    el.find('input[name=nc_token]').val('');
    nc.reset();
  };
  this.check = function () {
    return (
      el.find('input[name=csessionid]').val() &&
      el.find('input[name=sig]').val() &&
      el.find('input[name=nc_token]').val()
    );
  };
  this.success = function (arg) {
    callback = arg;
  };
  this.data = function (data) {
    data = data || {};
    data.csessionid = el.find('input[name=csessionid]').val();
    data.sig = el.find('input[name=sig]').val();
    data.nc_token = el.find('input[name=nc_token]').val();
    data.scene = el.find('input[name=scene]').val();
    return data;
  };
}
